import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Sale";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const ChangeStatus = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ChangeStatus`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const UpdateSale = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateSale`, options);

export const UpdateSaleDate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateSaleDate`, options);

export const UpdateCheckout = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateCheckout`, options);

export const UpdatePay = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdatePay`, options);

export const UpdateParasutInvoiceId = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:saleId/UpdateParasutInvoiceId`, options);

export const CreateManualDebt = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CreateManualDebt`, options);

/**
 * Eksik checkout finansal summary ve basket nihai fiyat alanlarını arka plan kuyruğunda doldurur.
 * @param {{ params?: object, query?: object }} options
 */
export const BackfillCheckoutFinancialSnapshots = (options) =>
  GENERATE_URL(`${PREFIX_URL}/BackfillCheckoutFinancialSnapshots`, options);

export default {
  GetAll,
  ChangeStatus,
  GetById,
  UpdateSale,
  UpdateSaleDate,
  UpdateCheckout,
  UpdatePay,
  UpdateParasutInvoiceId,
  CreateManualDebt,
  BackfillCheckoutFinancialSnapshots,
};
